// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"FileUpload_errorMessage__3ZlIB","errorPlaceholder":"FileUpload_errorPlaceholder__1uPCb","inputBoxOuter":"FileUpload_inputBoxOuter__12_EK"};